import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-16792721"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "relative flex flex-col items-center h-full px-5 pt-20 pb-12" };
const _hoisted_2 = { class: "flex" };
const _hoisted_3 = { class: "w-64 mx-5" };
const _hoisted_4 = { class: "mb-5 text-lg font-medium text-primary-800 dark:text-gray-300" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_6 = { class: "flex" };
const _hoisted_7 = { class: "w-20 h-20 m-2 border border-gray-300 rounded-lg dark:border-gray-600" };
const _hoisted_8 = ["src"];
const _hoisted_9 = { class: "text-sm font-medium text-center text-gray-900 dark:text-gray-100" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.lobby')
};
import ActivityImage from '@/components/new/ActivityImage.vue';
import AskIceBreakerDialog from '@/components/ice_breakers/AskIceBreakerDialog.vue';
import AnswerIceBreakerDialog from '@/components/ice_breakers/AnswerIceBreakerDialog.vue';
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'SetupPhase',
    setup(__props) {
        const retroStore = useRetroStore();
        const { activity, isPreparingIceBreaker, iceBreakerQuestion } = storeToRefs(retroStore);
        return (_ctx, _cache) => {
            const _component_section_heading = _resolveComponent("section-heading");
            const _component_i18n_t = _resolveComponent("i18n-t");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                (_unref(isPreparingIceBreaker))
                    ? (_openBlock(), _createBlock(AskIceBreakerDialog, {
                        key: 0,
                        class: "absolute absolute-center-x top-5"
                    }))
                    : (_unref(iceBreakerQuestion))
                        ? (_openBlock(), _createBlock(AnswerIceBreakerDialog, {
                            key: 1,
                            class: "absolute absolute-center-x top-5"
                        }))
                        : _createCommentVNode("", true),
                _createVNode(_component_section_heading, {
                    heading: _ctx.$t('heading')
                }, null, 8, ["heading"]),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(ActivityImage, {
                            class: "w-full h-full",
                            activity: _unref(activity)
                        }, null, 8, ["activity"])
                    ]),
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(`activities.${_unref(activity).id}.name`)), 1),
                        _createVNode(_component_i18n_t, {
                            keypath: `activities.${_unref(activity).id}.description`,
                            class: "mb-4 text-sm text-gray-400 max-w-112",
                            tag: "p"
                        }, {
                            default: _withCtx(() => [
                                _hoisted_5
                            ], undefined, true),
                            _: 1
                        }, 8, ["keypath"]),
                        _createElementVNode("div", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activity).topicTypes, (t) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: t.id
                                }, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("img", {
                                            src: t.image,
                                            class: "w-full h-full"
                                        }, null, 8, _hoisted_8)
                                    ]),
                                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(`activities.${_unref(activity).id}.topic_types.${t.id}.name`)), 1)
                                ]));
                            }), 128))
                        ])
                    ])
                ])
            ]));
        };
    }
});
